import React from "react";
import { Helmet } from 'react-helmet-async';

const SeoMeta = ({ data }) => {
    if (!data) return null;
    console.log("Metadata", data)
    
    const {
        title,
        field_banner_image,
        field_intro_inside_page,
        url,
        issue_info
    } = data;


    // Remove HTML tags from description
    const description = field_intro_inside_page
        ?.replace(/<[^>]*>/g, "")
        ?.slice(0, 200);

    console.log("title", title)
    console.log("field_banner_image", field_banner_image)
    console.log("field_intro_inside_page", field_intro_inside_page)
    console.log("issue_info", issue_info)
    console.log("description", description)

    return (
        
        <Helmet>
            {/* Page Title */}
            <title>{title}</title>

            {/* <!-- Social: Twitter --> */}
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="Mahindra Echo" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={field_banner_image} />

            {/* <!-- Social: Facebook / Open Graph --> */}
            {/* Open Graph (Facebook / WhatsApp) */}
            <meta property="og:type" content="article" />
            <meta property="og:site_name" content="Mahindra Echo" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={field_banner_image} /> 
            <meta property="og:url" content={window?.location?.href} />  

            {/* <!-- Social: Google+ / Schema.org  --> */}
            <meta itemprop="name" content="Mahindra Echo" />
            <meta itemprop="title" content={title} />
            <meta itemprop="description" content={description} />
            <meta itemprop="image" content={field_banner_image} />
        </Helmet>
    );
};

export default SeoMeta;
